module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header_box_3"
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "auto"
    },
    style: ({
      height: (_vm.pullHeight - 66) + 'px'
    })
  }, [_c('tab', {
    attrs: {
      "activeColor": '#118eea',
      "lineWidth": 2,
      "defaultColor": '#353535'
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.type = 1
      }
    }
  }, [_c('span', {
    staticClass: "sp-title",
    staticStyle: {
      "display": "block",
      "height": "20px",
      "border-right": "1px #ddd solid"
    }
  }, [_vm._v("单位")])]), _vm._v(" "), _c('tab-item', {
    nativeOn: {
      "click": function($event) {
        _vm.type = 0
      }
    }
  }, [_c('span', {
    staticClass: "sp-title",
    staticStyle: {
      "display": "block",
      "height": "20px"
    }
  }, [_vm._v("个人")])])], 1), _vm._v(" "), (_vm.type === 1) ? _c('group', {
    attrs: {
      "gutter": "0em"
    },
    on: {
      "click": function($event) {
        return _vm.onShowConfirm(_vm.item)
      }
    }
  }, [_c('x-input', {
    attrs: {
      "placeholder": "请填写准确的抬头信息",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card1.name),
      callback: function($$v) {
        _vm.$set(_vm.card1, "name", $$v)
      },
      expression: "card1.name"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.7em",
      "width": "5em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('sup', {
    staticStyle: {
      "margin-left": "-10px",
      "float": "left",
      "width": "3px",
      "color": "#F00"
    }
  }, [_vm._v("*")]), _vm._v("名 称")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "placeholder": "请填写企业纳税人识别号",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card1.taxpayerNo),
      callback: function($$v) {
        _vm.$set(_vm.card1, "taxpayerNo", $$v)
      },
      expression: "card1.taxpayerNo"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "2em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('sup', {
    staticStyle: {
      "margin-left": "-10px",
      "float": "left",
      "width": "3px",
      "color": "#F00"
    }
  }, [_vm._v("*")]), _vm._v("税号")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "placeholder": "请填写收票人手机号",
      "placeholder-align": "right",
      "show-clear": _vm.showClear
    },
    model: {
      value: (_vm.card1.mobile),
      callback: function($$v) {
        _vm.$set(_vm.card1, "mobile", $$v)
      },
      expression: "card1.mobile"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.4em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("手机号")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请填写收票人电子邮箱",
      "placeholder-align": "right",
      "show-clear": _vm.showClear
    },
    model: {
      value: (_vm.card1.email),
      callback: function($$v) {
        _vm.$set(_vm.card1, "email", $$v)
      },
      expression: "card1.email"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "单位地址",
      "placeholder": "请填写收票单位注册地址",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card1.address),
      callback: function($$v) {
        _vm.$set(_vm.card1, "address", $$v)
      },
      expression: "card1.address"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "电话号码",
      "placeholder": "请填写公司电话号码",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card1.telephone),
      callback: function($$v) {
        _vm.$set(_vm.card1, "telephone", $$v)
      },
      expression: "card1.telephone"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "开户银行",
      "placeholder": "请填写收票单位开户银行",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card1.depositBank),
      callback: function($$v) {
        _vm.$set(_vm.card1, "depositBank", $$v)
      },
      expression: "card1.depositBank"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "银行账号",
      "placeholder": "请填写收票单位银行账号",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card1.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.card1, "bankAccount", $$v)
      },
      expression: "card1.bankAccount"
    }
  }), _vm._v(" "), _c('x-switch', {
    attrs: {
      "title": "默认抬头"
    },
    model: {
      value: (_vm.card1.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.card1, "isDefault", $$v)
      },
      expression: "card1.isDefault"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 1) ? _c('div', [_c('P', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#888",
      "font-size": "14px",
      "padding-left": "15px"
    }
  }, [_vm._v("建议全部填写，以便开具增值税专用发票")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('group', {
    attrs: {
      "gutter": "0em"
    },
    on: {
      "click": function($event) {
        return _vm.onShowConfirm(_vm.item)
      }
    }
  }, [_c('x-input', {
    attrs: {
      "placeholder": "请填写准确的抬头信息",
      "show-clear": _vm.showClear,
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card2.name),
      callback: function($$v) {
        _vm.$set(_vm.card2, "name", $$v)
      },
      expression: "card2.name"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.7em",
      "width": "5em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('sup', {
    staticStyle: {
      "color": "#F00",
      "margin-left": "-10px",
      "float": "left",
      "width": "3px"
    }
  }, [_vm._v("*")]), _vm._v("名 称")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": _vm.showClear,
      "placeholder": "请填写收票人手机号",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card2.mobile),
      callback: function($$v) {
        _vm.$set(_vm.card2, "mobile", $$v)
      },
      expression: "card2.mobile"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.4em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("手机号")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": _vm.showClear,
      "placeholder": "请填写收票人电子邮箱",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.card2.email),
      callback: function($$v) {
        _vm.$set(_vm.card2, "email", $$v)
      },
      expression: "card2.email"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("电子邮箱")])]), _vm._v(" "), _c('x-switch', {
    attrs: {
      "title": "默认抬头"
    },
    model: {
      value: (_vm.card2.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.card2, "isDefault", $$v)
      },
      expression: "card2.isDefault"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "queding",
    staticStyle: {
      "position": "static"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/invoiceCard/')
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": "3000"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08cb66ec"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/addCard.vue
// module id = 319
// module chunks = 0